module.exports = __webpack_public_path__ + "static/media/image12.1d0b42f1.jpg";